import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthServiceBase } from '../services/auth/auth.service.base';
import { UserAccessStore } from '../services/user-access/user-access.store';
import { RegisteredApplicationStore } from '../services/registered-applications/registered-application.store';

export const developerEntryGuard: CanActivateFn = () => {
  const auth = inject(AuthServiceBase);
  const store = inject(UserAccessStore);
  const reg = inject(RegisteredApplicationStore);
  const router = inject(Router);

  if (!auth.isAuthenticated()) {
    return router.parseUrl('/projects');
  }

  return store.load().pipe(
    map((access) => {
      store.reconcilePreferredEntryWithAccess(access);
      if (access.isDeveloper) {
        store.setPreferredEntry('developer');
        reg.clear();
      }
      return router.parseUrl('/projects');
    }),
    catchError(() => of(router.parseUrl('/projects')))
  );
};
